import { render, staticRenderFns } from "./LevelItem.vue?vue&type=template&id=6fb4be0b&scoped=true&"
import script from "./LevelItem.vue?vue&type=script&lang=ts&"
export * from "./LevelItem.vue?vue&type=script&lang=ts&"
import style0 from "./LevelItem.vue?vue&type=style&index=0&id=6fb4be0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4be0b",
  null
  
)

export default component.exports